import { useCallback } from 'react';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
import { api } from '../assets/static/ApiRoutes';
import { ScanManagerInvoiceItem } from '../types/ScanManagerInvoices';

const useGetInvoiceAttachmentsApi = (invoiceId: number) => {
  const call = useCallback(
    () =>
      new Promise<ScanManagerInvoiceItem[]>(async (resolve, reject) => {
        try {
          const response = await axiosInstance.get<ScanManagerInvoiceItem[]>(
            api.getInvoiceAttachments(invoiceId)
          );
          resolve(response.data);
          return response.data as ScanManagerInvoiceItem[];
        } catch (error) {
          console.error(error);
          reject(error);
          throw new Error(error.message);
        }
      }),
    [invoiceId]
  );
  const { execute, isLoading } = useAsync(call, false);

  return { getInvoiceAttachments: execute, isInvoiceAttachmentsLoading: isLoading } as const;
};

export default useGetInvoiceAttachmentsApi;
